import React, { useState } from "react";
import axios from "axios";
import { sendRequest } from "../../utils/api";
import FullPageSpinner from "../../components/FullPageSpinner";

const AssignStaffIDPage = () => {
    const [email, setEmail] = useState("");
    const [staffID, setStaffID] = useState("");
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError("");
        setSuccess("");

        if (!email || !staffID) {
            setError("Please enter both email and Staff ID.");
            return;
        }

        try {

            const data = {
                staffEmail: email,
                staffId: staffID
            };

            setLoading(true);
            await sendRequest("POST", "/users/assign-id", data);
            // const response = await axios.post("/users/assign-id", {
            //     email,
            //     staffID,
            // });

            setSuccess("Staff ID assigned successfully!");
            setEmail("");
            setStaffID("");

        } catch (err: any) {
            if (err.status === 404) setError("User Not Found.");
            else setError("Failed to assign Staff ID. Try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4">
            <FullPageSpinner show={loading} />
            <div className="bg-white rounded-lg shadow-lg p-8 w-full max-w-md">
                <h1 className="text-2xl font-bold mb-6 text-center">Assign Staff ID</h1>

                {error && (
                    <div className="bg-red-100 text-red-700 px-4 py-2 rounded mb-4">{error}</div>
                )}
                {success && (
                    <div className="bg-green-100 text-green-700 px-4 py-2 rounded mb-4">{success}</div>
                )}

                <form onSubmit={handleSubmit} className="space-y-4">
                    <div>
                        <label className="block text-gray-700 mb-1 font-medium">Staff Email</label>
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="staff@example.com"
                            className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                            required
                        />
                    </div>

                    <div>
                        <label className="block text-gray-700 mb-1 font-medium">Staff ID</label>
                        <input
                            type="text"
                            value={staffID}
                            onChange={(e) => setStaffID(e.target.value)}
                            // placeholder="Enter Staff ID"
                            className="w-full border border-gray-300 rounded px-3 uppercase py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                            required
                        />
                    </div>

                    <button
                        type="submit"
                        disabled={loading}
                        className="w-full bg-blue-600 text-white font-medium py-2 rounded hover:bg-blue-700 transition-colors disabled:opacity-50"
                    >
                        {loading ? "Saving..." : "Assign ID"}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default AssignStaffIDPage;